// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1_TOW","cls2":"SimplePaperPodcast-cls2_ycb SimplePaperPodcast-cls1_TOW"};